export default String.raw`
<div class="header-top-bar header-top-bar-js">
    <div class="header-top-bar__side">
        {% if usr.Authenticated and customer.Supervisor -%}
            {% assign supervisor = customer.Supervisor -%}
            <div class="header-top-bar__supervisor header-supervisor-js">
                <button class="header__btn toggle-dropdown-js" data-container=".header-supervisor-js">
                    <svg height="24" width="24" class="header__btn-icon">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#comment-alt-dots-{{settings.iconStyle}}"></use>
                    </svg>
                    <span>{{ translations.ContactSupervisor }}</span>
                </button>
                <div class="form-js dropdowns-js dropdown-js dropdown-supervisor hidden-js">
                    <div class="dropdown-supervisor__header">
                        <h3>{{ translations.ContactSupervisor }}</h3>
                        <button class="close-button toggle-dropdown-js" aria-label="{{ translations.Close }}" data-container=".header-supervisor-js">
                            <svg aria-hidden="true" height="24" width="24">
                                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
                            </svg>
                        </button>
                    </div>
                    <div class="supervisor">
                        <div class="supervisor__img">
                            {% if supervisor.ImageUrl == null -%}
                                <svg {% if settings.showGuardianNameAs != 'nothing' -%} title="{{supervisor.FirstName}} {% if settings.showGuardianNameAs == 'name-and-surname' -%}{{supervisor.LastName}}{% endif -%}" {% endif -%}>
                                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#user-{{settings.iconStyle}}"></use>
                                </svg>
                            {% else -%}
                                <img src="css/img/alo.gif" data-src="{{supervisor.ImageUrl}}" {% if settings.showGuardianNameAs != 'nothing' -%} title="{{supervisor.FirstName}} {% if settings.showGuardianNameAs == 'name-and-surname' -%}{{supervisor.LastName}}{% endif -%}" {% endif -%}>
                            {% endif -%}
                        </div>
                        <div class="supervisor__info">
                            <div class="supervisor__info-details">
                                {% if settings.showGuardianNameAs != 'nothing' -%}{{ translations.YourSupervisor }}:<span>{{supervisor.FirstName}} {% if settings.showGuardianNameAs == 'name-and-surname' -%}{{supervisor.LastName}}{% endif -%}{% endif -%}</span>
                            </div>
                            <div class="supervisor__info-details">
                                <svg height="24" width="24">
                                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#envelope-{{settings.iconStyle}}"></use>
                                </svg>
                                <a class="phone" href="mailto:{{ supervisor.Email }}">{{ supervisor.Email }}</a>
                            </div>
                            {% if settings.showGuardianPhoneNo == 'yes' and supervisor.PhoneNo != '' -%}
                                {% assign showSupervisorPhone = true -%}
                            {% endif -%}
                            {% if settings.showGuardianPhoneNo == 'main-phone' and config.Shop.Contact.PhoneNo != '' -%}
                                {% assign showMainPhone = true -%}
                            {% endif -%}
                            {% if showSupervisorPhone or showMainPhone -%}
                                <div class="supervisor__info-details">
                                    <svg height="24" width="24" class="contact-info__icon">
                                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#headset-{{settings.iconStyle}}"></use>
                                    </svg>
                                    {% if showSupervisorPhone -%}
                                        <a class="phone" href="tel:{{supervisor.PhoneNo}}">{{supervisor.PhoneNo}}</a>
                                    {% else -%}
                                        <a class="phone" href="tel:{{config.Shop.Contact.PhoneNo}}">{{config.Shop.Contact.PhoneNo}}</a>
                                    {% endif -%}
                                </div>
                            {% endif -%}
                        </div>
                    </div>
                </div>
            </div>
        {% else -%}
            {% if config.Shop.Contact.PhoneNo != '' -%}
                <a aria-label="{{translations.PhoneNumber}} {{ config.Shop.Contact.PhoneNo }}" href="tel:{{ config.Shop.Contact.PhoneNo }}" class="header-top-bar__info" title="{{ translations.Call }}">
                    <svg height="24" width="24" class="header-top-bar__info-icon">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#headset-{{settings.iconStyle}}"></use>
                    </svg>
                    <span>{{ config.Shop.Contact.PhoneNo }}</span>
                </a>
            {% endif -%}
            {% if config.Shop.Contact.Email != '' -%}
                <a href="mailto:{{ config.Shop.Contact.Email }}" class="header-top-bar__info" title="{{ translations.WriteToUs }}">                 
                    <svg height="24" width="24" class="header-top-bar__info-icon">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#envelope-{{settings.iconStyle}}"></use>
                    </svg>
                    <span>{{ config.Shop.Contact.Email }}</span>
                </a>
            {% endif -%}
        {% endif -%}
    </div>
    <div class="header-top-bar__side">
        {% if usr.Authenticated -%}
            <div class="header-top-bar__company current-company-js">
                 {% assign companiesNumber = customer.Companies | Size -%}
                 {% if companiesNumber > 1 -%}
                    <button class="header__btn toggle-dropdown-js" data-container=".current-company-js" title="{{ translations.ChangeCompany }}">
                 {% else -%}
                    <span class="header-top-bar__info">
                 {% endif -%}
                        {% assign currentCompany = '' -%}
                        <span class="header-top-bar__company-name">
                            {% for name in customer.Companies -%}
                                {% if name.Id == customer.CompanyId -%}
                                    {{name.Name}} {{name.Name2}}
                                    {% assign currentCompany = name.Name | Plus: ' ' | Plus: name.Name2 -%}
                                    {% break -%}
                                {% endif -%}
                            {% endfor -%}
                        </span>
                        {% if companiesNumber > 1 -%}
                            <svg height="24" width="24" class="header__btn-icon">
                                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}"></use>
                            </svg>
                        {% endif -%}
                 {% if companiesNumber <= 1 -%}
                     </span>
                 {% else -%}
                     </button>
                 {% endif -%}

                {% if companiesNumber > 1 -%}
                    {% capture currentPageUrl -%}{% include 'partials/common/user-link.html', userLink: page.Url -%}{% endcapture -%}
                    <div class="header__dropdown dropdowns-js dropdown-js hidden-js form-js" action="{{ currentPageUrl }}{{ page.QueryString | H}}" >
                        <input type="hidden" name="__action" value="Customer/CompanyChange" >
                        <input type="hidden" name="id" value="" >

                       {% assign customerCompaniesSize = customer.Companies | Size -%}

                       {% if customerCompaniesSize > 3 -%}
                           <div class="header-top-bar__company-search">
                               <input type="text" id="company-search-input" class="change-employee-company-search-js" placeholder="{{translations.Search}}..." aria-label="{{translations.Search}}">
                               <svg height="20" width="20" class="header__btn-icon">
                                   <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#search-{{settings.iconStyle}}"></use>
                               </svg>
                           </div>
                       {% endif -%}

                        <ul class="header__dropdown-list header-top-bar__company-list change-employee-company-elements-js">
                            {% for company in customer.Companies -%}
                                <li id="{{ company.Id }}" class="header__dropdown-item change-employee-company-item-js" data-name="{{ company.Name }}">
                                    <span class="change-employee-company-text-js">{{ company.Name }}</span>
                                    <input type="hidden" value="{{ company.Id }}">
                                </li>
                            {% endfor -%}
                        </ul>
                    </div>
                {% endif -%}
            </div>
        {% endif -%}

        {% if usr.Authenticated or notAuth -%}
            <div class="header-top-bar__currency change-currency-js select-wcag-js">
                {% assign currCount = config.Currencies | Size -%}
                {% if config.ENTERPRISE and currCount > 1 and customer.Cart.EditedOrderId == null -%}
                    <button class="header__btn toggle-dropdown-js" title="{{ translations.ChangeCurrency }}" data-container=".change-currency-js">
                        <span class="header-top-bar__currency-name">{{ customer.CurrencyExt.Symbol }}</span>
                        <svg height="24" width="24" class="header__btn-icon">
                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}"></use>
                        </svg>
                    </button>
                {% else -%}
                    <span class="header-top-bar__info">
                        <span>{{ customer.CurrencyExt.Symbol }}</span>
                    </span>
                {% endif -%}

                {% if config.ENTERPRISE and currCount > 1 and customer.Cart.EditedOrderId == null -%}
                    <div class="header__dropdown no-padding form-js dropdowns-js dropdown-js currency-dropdown-js hidden-js">
                        <input type="hidden" name="__action" value="Customer/CurrencyChange" >
                        <input type="hidden" name="currency">
                        <ul class="header__dropdown-list header-top-bar__currency-list">
                            <li tabindex="-1" data-val="{{ customer.Currency }}" class="header-top-bar__currency-item header__dropdown-item">{{ customer.CurrencyExt.Code }} - {{ customer.CurrencyExt.Symbol }}</li>
                            {% for curr in config.Currencies -%}
                                {% if curr.Code != customer.Currency -%}
                                    <li tabindex="0" data-val="{{ curr.Code }}" class="header__dropdown-item">{{ curr.Code }} - {{ curr.Symbol }}</li>
                                {% endif -%}
                            {% endfor -%}
                        </ul>
                    </div>
                {% endif -%}
            </div>
        {% endif -%}

        <div class="header-top-bar__language change-lang-js select-wcag-js">
            {% assign currentLang = config.Languages[page.LanguageId] -%}
            {% assign languagesSize = config.Languages | Size -%}
            {% if languagesSize > 1 -%}
                <button class="header__btn header-top-bar__language-btn toggle-dropdown-js" data-container=".change-lang-js" title="{{translations.ChangeLanguage}}">
                    <span class="flag flag-{{currentLang.Language}}" title="{{currentLang.Name}}"></span>
                    <span class="header-top-bar__language-name">{{ currentLang.Language }}</span>
                    <svg height="24" width="24" class="header__btn-icon">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}"></use>
                    </svg>
                </button>
            {% else -%}
                <span class="header-top-bar__info" title="{{currentLang.Name}}">
                    <span class="flag flag-{{currentLang.Language}}"></span>
                    <span class="header-top-bar__language-name">{{ currentLang.Language }}</span>
                </span>
            {% endif -%}

            {% if languagesSize > 1 -%}
                <div class="header__dropdown no-padding form-js dropdowns-js dropdown-js lang-dropdown-js hidden-js">
                    <input type="hidden" name="__action" value="Customer/LanguageChange" >
                    <input type="hidden" name="languageId" >
                    <ul class="header__dropdown-list header-top-bar__currency-list">
                        <li tabindex="0" data-val="{{currentLang.Id}}" data-lname="{{ currentLang.Language }}" class="header-top-bar__language-item header__dropdown-item">
                            <span class="flag flag-{{currentLang.Language}}" title="{{currentLang.Name}}"></span>
                            <span class="header-top-bar__language-name">{{ currentLang.Language }}</span>
                        </li>
                        {% for lng in config.Languages -%}
                            {% if lng.Id != currentLang.Id -%}
                                <li tabindex="0" data-val="{{ lng.Id }}" data-lname="{{ lng.Language }}" class="header-top-bar__language-item header__dropdown-item">
                                    <span class="flags flag flag-{{lng.Language}}" title="{{lng.Name}}"></span>
                                    <span class="header-top-bar__language-name">{{ lng.Language }}</span>
                                </li>
                            {% endif -%}
                        {% endfor -%}
                    </ul>
                </div>
            {% endif -%}
        </div>

        {% if settings.google_translate == 'google_translate-yes' -%}          
            <div id="google_translate_element"></div>
		{% endif -%}
    </div>
</div>
`